<p class="title" *ngIf="!insideModal">
  {{ 'MANAGE_VACATIONS.BEFORE_REQUEST_VACATIONS_CHECK' | translate }}
</p>
<app-title-description-card
  [cardTitle]="'MANAGE_VACATIONS.VACATIONS_CRITERIA' | translate"
  [cardDescription]="criteria.generalInformation"
  [insideModal]="insideModal"
  *ngIf="criteria"></app-title-description-card>
